import { render, staticRenderFns } from "./SocialReviewsAutoAnswers.vue?vue&type=template&id=cd0dd560&scoped=true&"
import script from "./SocialReviewsAutoAnswers.vue?vue&type=script&lang=js&"
export * from "./SocialReviewsAutoAnswers.vue?vue&type=script&lang=js&"
import style0 from "./SocialReviewsAutoAnswers.vue?vue&type=style&index=0&id=cd0dd560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0dd560",
  null
  
)

export default component.exports